// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/touchpoint_proposals.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * Immutable permitted source snapshot. revision is SHA-256 of extracted text.
 *
 * @generated from message mono.datagateway.v1.TouchpointProposalSource
 */ export class TouchpointProposalSource extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointProposalSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointProposalSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointProposalSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointProposalSource, a, b);
    }
    constructor(data){
        super(), /**
   * notes or attachment
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string ref = 2;
   */ _define_property(this, "ref", ""), /**
   * @generated from field: string revision = 3;
   */ _define_property(this, "revision", ""), /**
   * @generated from field: string text = 4;
   */ _define_property(this, "text", ""), /**
   * exact substring, required for FACT
   *
   * @generated from field: string excerpt = 5;
   */ _define_property(this, "excerpt", ""), /**
   * @generated from field: string source_date = 6;
   */ _define_property(this, "sourceDate", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointProposalSource, "runtime", proto3);
_define_property(TouchpointProposalSource, "typeName", "mono.datagateway.v1.TouchpointProposalSource");
_define_property(TouchpointProposalSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TouchpointProposalInput
 */ export class TouchpointProposalInput extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointProposalInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointProposalInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointProposalInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointProposalInput, a, b);
    }
    constructor(data){
        super(), /**
   * summary, follow_ups, inferred_need
   *
   * @generated from field: string target_field = 1;
   */ _define_property(this, "targetField", ""), /**
   * FACT or INFERENCE
   *
   * @generated from field: string classification = 2;
   */ _define_property(this, "classification", ""), /**
   * @generated from field: string proposed_value = 3;
   */ _define_property(this, "proposedValue", ""), /**
   * @generated from field: string rationale = 4;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string uncertainty = 5;
   */ _define_property(this, "uncertainty", ""), /**
   * @generated from field: string contradictions = 6;
   */ _define_property(this, "contradictions", ""), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposalSource sources = 7;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointProposalInput, "runtime", proto3);
_define_property(TouchpointProposalInput, "typeName", "mono.datagateway.v1.TouchpointProposalInput");
_define_property(TouchpointProposalInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "classification",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "uncertainty",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contradictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sources",
            kind: "message",
            T: TouchpointProposalSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TouchpointProposal
 */ export class TouchpointProposal extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointProposal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string interaction_id = 2;
   */ _define_property(this, "interactionId", ""), /**
   * @generated from field: mono.datagateway.v1.TouchpointProposalInput draft = 3;
   */ _define_property(this, "draft", void 0), /**
   * pending, accepted, rejected
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reviewer_id = 5;
   */ _define_property(this, "reviewerId", ""), /**
   * @generated from field: optional string applied_value = 6;
   */ _define_property(this, "appliedValue", void 0), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 7;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointProposal, "runtime", proto3);
_define_property(TouchpointProposal, "typeName", "mono.datagateway.v1.TouchpointProposal");
_define_property(TouchpointProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft",
            kind: "message",
            T: TouchpointProposalInput
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "applied_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTouchpointProposalsRequest
 */ export class CreateTouchpointProposalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTouchpointProposalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTouchpointProposalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTouchpointProposalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTouchpointProposalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 3;
   */ _define_property(this, "interactionId", ""), /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */ _define_property(this, "expectedUpdatedAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposalInput drafts = 5;
   */ _define_property(this, "drafts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTouchpointProposalsRequest, "runtime", proto3);
_define_property(CreateTouchpointProposalsRequest, "typeName", "mono.datagateway.v1.CreateTouchpointProposalsRequest");
_define_property(CreateTouchpointProposalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "drafts",
            kind: "message",
            T: TouchpointProposalInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTouchpointProposalsResponse
 */ export class CreateTouchpointProposalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTouchpointProposalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTouchpointProposalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTouchpointProposalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTouchpointProposalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposal proposals = 1;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTouchpointProposalsResponse, "runtime", proto3);
_define_property(CreateTouchpointProposalsResponse, "typeName", "mono.datagateway.v1.CreateTouchpointProposalsResponse");
_define_property(CreateTouchpointProposalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposals",
            kind: "message",
            T: TouchpointProposal,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTouchpointProposalsRequest
 */ export class ListTouchpointProposalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointProposalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointProposalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointProposalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointProposalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 3;
   */ _define_property(this, "interactionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointProposalsRequest, "runtime", proto3);
_define_property(ListTouchpointProposalsRequest, "typeName", "mono.datagateway.v1.ListTouchpointProposalsRequest");
_define_property(ListTouchpointProposalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTouchpointProposalsResponse
 */ export class ListTouchpointProposalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTouchpointProposalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTouchpointProposalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTouchpointProposalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTouchpointProposalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointProposal proposals = 1;
   */ _define_property(this, "proposals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTouchpointProposalsResponse, "runtime", proto3);
_define_property(ListTouchpointProposalsResponse, "typeName", "mono.datagateway.v1.ListTouchpointProposalsResponse");
_define_property(ListTouchpointProposalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposals",
            kind: "message",
            T: TouchpointProposal,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewTouchpointProposalRequest
 */ export class ReviewTouchpointProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewTouchpointProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewTouchpointProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewTouchpointProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewTouchpointProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string interaction_id = 3;
   */ _define_property(this, "interactionId", ""), /**
   * @generated from field: string proposal_id = 4;
   */ _define_property(this, "proposalId", ""), /**
   * accepted or rejected; terminal
   *
   * @generated from field: string decision = 5;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: optional string edited_value = 6;
   */ _define_property(this, "editedValue", void 0), /**
   * resolved by zou, never browser supplied
   *
   * @generated from field: string reviewer_id = 7;
   */ _define_property(this, "reviewerId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewTouchpointProposalRequest, "runtime", proto3);
_define_property(ReviewTouchpointProposalRequest, "typeName", "mono.datagateway.v1.ReviewTouchpointProposalRequest");
_define_property(ReviewTouchpointProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "interaction_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "edited_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "reviewer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewTouchpointProposalResponse
 */ export class ReviewTouchpointProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewTouchpointProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewTouchpointProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewTouchpointProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewTouchpointProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TouchpointProposal proposal = 1;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewTouchpointProposalResponse, "runtime", proto3);
_define_property(ReviewTouchpointProposalResponse, "typeName", "mono.datagateway.v1.ReviewTouchpointProposalResponse");
_define_property(ReviewTouchpointProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: TouchpointProposal
        }
    ]));
